module.exports = __webpack_public_path__ + "static/img/6e.4b7ea42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6e.jpg
// module id = sOM+
// module chunks = 1